export default {
  'login.title': 'اختر من بين الخيارات السهلة',
};
